<template>
  <v-form ref="formMaterialBlock" class="block-wrapper academy-block">
    <header-title :main-title="mainTitle" v-if="mainTitle" />

    <div class="block-container" :inert="scheduleBusy || scheduleLocked ? true : undefined">
      <!-- Заголовок -->
      <title-slot :is-active-big-title="true" :title="inputInfo.title">
        <input-main
            :rules="rulesRequired"
            @changeValue="value => form.title = value.value"
            :value="form.title"
            :info-input="inputInfo"
        />
      </title-slot>

      <!-- Тип материала -->
      <title-slot title="Тип">
        <v-select
            class="custom-select"
            label="Выберите тип"
            v-model="form.type"
            :items="selects.type"
            item-title="label"
            item-value="label"
            return-object
        />
      </title-slot>

      <title-slot :is-active-big-title="true" :title="inputDescription.title">
        <input-main
            :active-textarea="true"
            :rules="rulesRequired"
            @changeValue="value => form.description = value.value"
            :value="form.description"
            :info-input="inputDescription"
        />
      </title-slot>

      <title-slot class="editor-wrapper" title="Текст (редактор)">
        <editor-container
            :active-item="form.text"
            profile="publication"
            @changeEditorContent="value => form.text = value"
            @contentValidation="value => editorValidation = value"
        />
      </title-slot>

      <!-- Изображение -->
      <title-slot title="Добавить изображение для превью">
        <file-input
            :file="defaultFileInput"
            :active-file="form.logo"
            :is-active-img="true"
            @removeFile="form.logo = null"
            @changeFile="(value, file, fileSrc) => form.logo = { file, fileSrc }"
            class="academy-file-input"
        />
      </title-slot>

      <!-- Дата публикации -->
      <title-slot title="Дата, указанная в материале">
        <picker-menu-date
            :value="form.publishedAt"
            @changeDate="value => form.publishedAt = value"
            placeholder="xx.xx.xxxx"
        />
      </title-slot>

      <!-- Теги -->
      <tags-block
          @changeTags="tags => form.tags = tags"
          :tags-title="tagsTitle"
          @closeTags="closeTags"
          :tags-out="form.tags"
      />

      <!-- SEO -->
      <title-slot :is-active-big-title="true" title="Тип материала">
        <v-select
            class="custom-select"
            label="Выберите тип материала"
            v-model="form.materialType "
            :items="selects.materials"
            item-title="label"
            item-value="label"
            return-object
        />
        <input-main
            v-if="form.materialType.label === 'Ссылка'"
            :rules="rulesRequired"
            @changeValue="value => form.linkUrl = value.value"
            :value="form.linkUrl"
            :info-input="inputInfoUrl"
        />
        <file-input
            v-else
            :file="defaultFileInputSecond"
            :active-file="form.file"
            :is-active-img="false"
            @removeFile="form.file = null"
            @changeFile="(value, file, fileSrc) => form.file = { file, fileSrc }"
        />
      </title-slot>

      <!-- URL -->
      <title-slot :is-active-big-title="true" title="URL страницы">
        <input-main
            @changeValue="value => form.url = value.value"
            :value="form.url"
            :info-input="inputInfoPageUrl"
        />
      </title-slot>

      <!-- SEO -->
      <title-slot :is-active-big-title="true" title="SEO">
        <input-main
            :active-textarea="true"
            @changeValue="value => form.metaTitle = value.value"
            :value="form.metaTitle"
            :info-input="inputInfoMetaTitle"
        />
        <input-main
            :active-textarea="true"
            @changeValue="value => form.metaDescription = value.value"
            :value="form.metaDescription"
            :info-input="inputInfoMetaDescription"
        />
        <input-main
            :active-textarea="true"
            @changeValue="value => form.keywords = value.value"
            :value="form.keywords"
            :info-input="inputInfoKeywords"
        />
      </title-slot>

      <!-- Форма-шлюз для скачивания -->
      <title-slot title="Форма перед скачиванием">
        <v-checkbox
            v-model="form.requiresForm"
            label="Требуется форма для скачивания"
            density="compact"
            hide-details
            color="primary"
        />
      </title-slot>
    </div>

    <publication-controls :record="scheduleRecord" v-model:schedule="scheduleInput" :busy="scheduleBusy"
      :draft-disabled="!form.title || !form.type || !form.description" :publish-disabled="idDisabledButton"
      :notice="scheduleNotice" @action="scheduleAction" />
  </v-form>
</template>

<script>
import HeaderTitle from "@/components/entities/HeaderTitle.vue";
import PickerMenuDate from "@/components/shared/picker/PickerMenuDate.vue";
import BigTitle from "@/components/shared/text/BigTitle.vue";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
import TitleSlot from "@/components/entities/TitleSlot.vue";
import InputMain from "@/components/shared/input/InputMain.vue";
import FileInput from "@/components/shared/input/FileInput.vue";
import TagsBlock from "@/components/entities/CRUDBlock/TagsBlock.vue";
import EditorContainer from "@/components/entities/EditorContainer.vue";
import RulesMixin from "@/mixins/rules.mixin";
import PublicationControls from "@/components/entities/PublicationControls.vue";
import PublicationScheduleMixin from "@/mixins/publication-schedule.mixin";
import { publicationDate } from "@/services/publication-schedule.mjs";
import {api} from "@/middleware/api";

export default {
  name: "AcademyBlock",
  mixins: [RulesMixin, PublicationScheduleMixin],
  components: {
    PublicationControls,
    HeaderTitle,
    PickerMenuDate,
    BigTitle,
    ButtonMain,
    TitleSlot,
    InputMain,
    FileInput,
    TagsBlock,
    EditorContainer,
  },
  data() {
    return {
      mainTitle: "Новый элемент",
      editorValidation: {valid: true, imagesWithoutAlt: 0, message: ''},
      defaultFileInput: {
        placeholder: "Загрузить изображение",
        mimetype: "image/png, image/jpeg, image/jpg",
        mimeTypeString: "PNG, JPEG, JPG",
        size: 0.0035,
        title: "Загрузите файл до 3.5 МБ",
      },
      defaultFileInputSecond: {
        placeholder: "Загрузить файл",
        mimetype: "application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, application/zip, application/x-rar-compressed",
        mimeTypeString: "DOC, DOCX, PDF, ZIP, RAR",
        size: 0.03,
        title: "Загрузите файл до 30 МБ",
      },
      publicationKind: 'academies',
      form: {
        title: "",
        description: '',
        text: '',
        publishedAt: null,
        type: "",
        materialType: {label: 'Ссылка', value: 'LINK'},
        logo: null,
        linkUrl: '',
        tags: [],
        file: null,
        url: '',
        metaTitle: '',
        metaDescription: '',
        keywords: '',
        requiresForm: false,
      },
      selects: {
        materials: [{label: 'Ссылка', value: 'LINK'}, {label: 'Файл', value: 'FILE'}],
        type: [{ label: 'Курсы', value: 'COURSE' }, { label: 'Гайды', value: 'GUIDE' }],
      }
    };
  },
  computed: {
    idDisabledButton() {
      return !this.form.title?.trim()
          || !this.form.description?.trim()
          || !this.form.description
          || !this.form.type
          || (!this.form.logo?.file && !this.form.logo?.logoKey)
          || (!this.form.file?.file && this.form.materialType.value === 'FILE')
          || (!this.form.linkUrl?.trim() && this.form.materialType.value === 'LINK')
          || !this.editorValidation.valid
    },
    tagsTitle() {
      return "Добавить теги";
    },
    inputInfo() {
      return {
        title: 'Заголовок',
        placeholder: "Введите текст",
      };
    },
    inputDescription() {
      return {
        title: 'Описание',
        placeholder: "Введите описание элемента",
        maxLength: 200,
      };
    },
    inputInfoUrl() {
      return { placeholder: "Введите ссылку" };
    },
    inputInfoPageUrl() {
      return {
        placeholder: 'Введите URL',
        type: 'big',
      }
    },
    inputInfoMetaTitle() {
      return { maxLength: 70, placeholder: 'Meta Title' }
    },
    inputInfoMetaDescription() {
      return { maxLength: 170, placeholder: 'Meta Description' }
    },
    inputInfoKeywords() {
      return { maxLength: 255, placeholder: 'Keywords' }
    }
  },
  async created() {
    const id = this.$route.params.id;
    if (id) {
      this.mainTitle = "Редактор элемента";

      this.IS_GLOBAL_LOADING(true)
      const { data } = await api.dashboard.adminAcademiesControllerFindOne(id)
      console.log('data', data)
      if (data) {
        this.form = {
          ...data,
          publishedAt: data.publication?.displayDate || data.publishedAt,
          tags: data.tags.map( e => e.id ),
          text: data.text || '',
          type: data.type === 'COURSE' ?  this.selects.type[0] : this.selects.type[1],
          materialType: data.materialType === 'LINK' ?  this.selects.materials[0] : this.selects.materials[1],
          logo: { logoKey: data.logo?.s3Key },
          file: { file: data.file, fileKey: true },
          url: data.url || '',
          metaTitle: data.seoTitle || '',
          metaDescription: data.seoDescriptions || '',
          keywords: data.keyWords || '',
          requiresForm: data.requiresForm || false,
        };
      }
      this.IS_GLOBAL_LOADING(false)
    } else {
      this.mainTitle = "Новый элемент";
    }
    await this.initSchedule(id);
  },

  methods: {
    publicationDisplayDate() { return this.form.publishedAt; },
    setPublicationDisplayDate(value) { this.form.publishedAt = value; },
    academyPayload() {
      return {
        title: this.form.title, description: this.form.description, text: this.form.text || '',
        type: this.form.type.value, materialType: this.form.materialType.value,
        ...(this.form.publishedAt ? { publishedAt: publicationDate(this.form.publishedAt) } : {}),
        ...(this.form.materialType.value === 'LINK' && this.form.linkUrl?.trim() ? { linkUrl: this.form.linkUrl } : {}),
        tags: this.form.tags, url: this.form.url, seoTitle: this.form.metaTitle,
        seoDescriptions: this.form.metaDescription, keyWords: this.form.keywords, requiresForm: this.form.requiresForm,
      };
    },
    async savePublicationDraft() {
      let item;
      if (!this.scheduleEntityId) {
        const { data } = await api.dashboard.adminAcademiesControllerCreate({ ...this.academyPayload(),
          ...(this.form.logo?.file ? { logo: this.form.logo.file } : {}) });
        item = data;
        this.scheduleEntityId = item.id;
        if (item.logo) this.form.logo = { logoKey: item.logo.s3Key };
      } else {
        if (this.form.logo?.file) {
          const { data } = await api.dashboard.adminAcademiesControllerUpdateLogo(this.scheduleEntityId, { file: this.form.logo.file, type: 'LOGO' });
          this.form.logo = { logoKey: data.logo.s3Key };
        }
        const { data } = await api.dashboard.adminAcademiesControllerUpdate(this.scheduleEntityId, this.academyPayload());
        item = data;
      }
      if (this.form.materialType.value === 'FILE' && this.form.file?.file && !this.form.file.fileKey) {
        const { data } = await api.dashboard.adminAcademiesControllerUpdateFile(item.id, { file: this.form.file.file, type: 'FILE' });
        this.form.file = { file: data.file, fileKey: true };
      }
      return item;
    },
    closeTags(tag) {
      const idx = this.form.tags.findIndex((t) => t === tag);
      if (idx !== -1) this.form.tags.splice(idx, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.header-title-container {
  margin-bottom: -40px;
}
.academy-block{
  max-width: 1000px;
  width: 100%;
  overflow-x: hidden;

  .academy-file-input{
    height: 400px;
  }

  .block-container {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }

  .title-slot-container {
    width: 100%;
    max-width: 100%;
  }

  :deep(.v-textarea) {
    width: 100%;
    max-width: 100%;

    .v-field {
      width: 100%;
      max-width: 100%;
    }

    .v-field__input {
      width: 100% !important;
      max-width: 100% !important;
    }

    textarea {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box;
      word-wrap: break-word;
      overflow-wrap: break-word;
      white-space: pre-wrap;
    }
  }

  :deep(.v-input) {
    width: 100%;
    max-width: 100%;
  }
}
</style>
